const sidebarConfig={/**
     * Width of expanded Sidebar on desktop in `px`.
     * Height is `100vh`.
     */desktopWidthExpanded:280,/**
     * Width of collapsed Sidebar on desktop in `px`.
     * Height is `100vh`.
     */desktopWidthCollapsed:65,/**
     * Height of expanded Sidebar on mobile in `px`.
     * Width is 100%.
     */mobileHeight:56,/**
     * Sidebar transition duration in `ms`.
     */transitionDuration:150};export default sidebarConfig;
//# sourceMappingURL=sidebar.config.js.map